/* global System */
// register component(s) with react habitat

export default { PublicationsRDGrid: () => System.import('./data') }
